import { ReactElement } from 'react';
import { Spin, SpinProps } from 'antd';

import './Circles.css';

type Props = SpinProps & {
  color?: string;
};

const Spinner = ({ size, ...rest }: Props): ReactElement => {
  return <Spin size={size} {...rest} />;
};

const CirclesSpinner = ({
  size,
  color,
}: {
  size?: 'small' | 'medium' | 'large' | 'largest';
  color?: string;
}): ReactElement => {
  const sizeClassName =
    size === 'small'
      ? 'la-sm'
      : size === 'large'
      ? 'la-2x'
      : size === 'largest'
      ? 'la-3x'
      : '';

  return (
    <div className={`la-ball-spin-clockwise ${sizeClassName}`}>
      <div style={{ color }} />
      <div style={{ color }} />
      <div style={{ color }} />
      <div style={{ color }} />
      <div style={{ color }} />
      <div style={{ color }} />
      <div style={{ color }} />
      <div style={{ color }} />
    </div>
  );
};

export { Spinner, CirclesSpinner };
